import {
  IWorkingDaysAnalyticsActivityEnum,
  IWorkingDaysAnalyticsActivityV2Enum,
} from 'lib/enum/working-days-analytics-activity.enum';

export interface AppTimeSeriesRaw {
  [IWorkingDaysAnalyticsActivityEnum.LocalStartTime]: string;
  [IWorkingDaysAnalyticsActivityEnum.TotalDuration]?: string;
  [IWorkingDaysAnalyticsActivityEnum.count]?: string;
  [IWorkingDaysAnalyticsActivityV2Enum.TotalCallDuration]?: string;
  [IWorkingDaysAnalyticsActivityV2Enum.CallCount]?: string;
}

export interface AppTimeSeriesV2Raw {
  [IWorkingDaysAnalyticsActivityV2Enum.LocalStartTime]: string;
  [IWorkingDaysAnalyticsActivityV2Enum.TotalDuration]?: string;
  [IWorkingDaysAnalyticsActivityV2Enum.count]?: string;
  [IWorkingDaysAnalyticsActivityV2Enum.TotalCallDuration]?: string;
  [IWorkingDaysAnalyticsActivityV2Enum.CallCount]?: string;
}
